import { render, staticRenderFns } from "./InstallerTab.vue?vue&type=template&id=b1775518&"
import script from "./InstallerTab.vue?vue&type=script&lang=js&"
export * from "./InstallerTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports